<div class="certificate-display">
    <div class="fixed-aspect">
        <canvas #canvas class="certificate-preview" width="792px" height="612px"></canvas>
    </div>
    <h5 class="certificate-description">
      {{ template.description }}
    </h5>
    <div class="certificate-actions">
      <a class="pointer" (click)="emailCertificate()" *ngIf="!isParent" ngbTooltip="Email"><i class="far fa-envelope fa-lg"></i></a>
      <a class="pointer" (click)="printCertificate()" ngbTooltip="Print"><i class="far fa-print fa-lg"></i></a>
      <a class="pointer" (click)="downloadCertificate()" ngbTooltip="Download"><i class="far fa-download fa-lg"></i></a>
    </div>
</div>
<app-email-certificate-modal #emailModal [openModalButtonVisible]="false"></app-email-certificate-modal>